export function NewTickets({ active = false }: any) {
  const color = active ? "#006AB3" : "#84818A";
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.981 9.25668V13.6645C19.981 16.75 18.2133 18.0724 15.5617 18.0724H6.72304C4.07144 18.0724 2.30371 16.75 2.30371 13.6645V7.49354C2.30371 4.40805 4.07144 3.08569 6.72304 3.08569H12.9101"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.72314 7.93408L9.48965 10.138C10.4 10.8609 11.8938 10.8609 12.8041 10.138L13.8471 9.30933"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.7717 7.05262C18.992 7.05262 19.9813 6.06589 19.9813 4.8487C19.9813 3.63151 18.992 2.64478 17.7717 2.64478C16.5513 2.64478 15.562 3.63151 15.562 4.8487C15.562 6.06589 16.5513 7.05262 17.7717 7.05262Z"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
